import React from "react"
import BlockMenuList from "./block-menu-list"
import AnchoredBlockMenuList from "./anchored-block-menu-list"
import { createInsertersFor, createMenuItem } from "./utils"

const InsertPersonalization = createMenuItem({
  onSelect: () => {},
  icon: "personalization",
  label: "Personalization",
  operation: "insert_personalization",
  type: "personalization"
})

const InsertSnippet = createMenuItem({
  onSelect: () => {},
  icon: "snippet",
  label: "Snippet",
  operation: "insert_snippet",
  type: "snippet"
})

const InsertBlockquote = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "blockquote"
      })
      .focus()
  },
  icon: "blockquote",
  label: "Blockquote",
  type: "blockquote"
})

const InsertUnorderedList = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "unordered-list"
      })
      .focus()
  },
  icon: "unorderedList",
  label: "Unordered List",
  type: "unordered-list"
})

const InsertOrderedList = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "ordered-list"
      })
      .focus()
  },
  icon: "orderedList",
  label: "Number List",
  type: "ordered-list"
})

const InsertParagraph = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "paragraph"
      })
      .focus()
  },
  icon: "paragraph",
  label: "Paragraph",
  type: "paragraph"
})

const InsertHeading = type =>
  createMenuItem({
    onSelect: editor => {
      editor
        .moveToEndOfBlock()
        .setBlocks({
          type: type
        })
        .focus()
    },
    icon: type,
    label: "Heading",
    type: type
  })

const InsertButton = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "button",
        data: editor.props.theme.button
      })
      .insertText("Button")
      .focus()
  },
  icon: "button",
  label: "Button",
  type: "button"
})

const InsertImage = createMenuItem({
  onSelect: () => {},
  icon: "image",
  label: "Image",
  operation: "insert_image",
  type: "image"
})

const InsertFile = createMenuItem({
  onSelect: () => {},
  icon: "file",
  label: "File",
  operation: "insert_file",
  type: "file"
})

const InsertHTMLBlock = createMenuItem({
  onSelect: editor => {
    editor.insertHTML({ html: "" }).focus()
  },
  icon: "html",
  label: "HTML Block",
  type: "html"
})

const InsertDivider = createMenuItem({
  onSelect: editor => {
    editor
      .setBlocks({
        type: "horizontal-rule"
      })
      .focus()
  },
  icon: "horizontalRule",
  label: "Divider",
  type: "horizontal-rule"
})

const InsertCountdownTimer = createMenuItem({
  onSelect: () => null,
  icon: "countdown",
  label: "Countdown Timer",
  type: "countdown_timer",
  operation: "insert_countdown_timer"
})

function BlockMenu({
  onSelect,
  onClick,
  collections = [],
  blocks = [],
  direction,
  anchor
}) {
  const isAllowed = slateBlock => option => {
    if (!slateBlock) return blocks.includes(option.type)
    if (blocks.length > 0 && !blocks.includes(option.type)) return false
    return true
  }

  function calculateOptions(block) {
    const options = [
      InsertImage,
      InsertButton,
      InsertDivider,
      InsertFile,
      InsertSnippet,
      InsertPersonalization,
      ...createInsertersFor(collections),
      InsertCountdownTimer,
      InsertHeading("heading-one"),
      InsertHeading("heading-two"),
      InsertHeading("heading-three"),
      InsertBlockquote,
      InsertUnorderedList,
      InsertOrderedList,
      InsertHTMLBlock,
      InsertParagraph
    ]

    return options.filter(isAllowed(block))
  }

  if (anchor) {
    return (
      <AnchoredBlockMenuList
        onSelect={onSelect}
        options={calculateOptions}
        direction={direction}
        anchor={anchor}
      />
    )
  }

  return (
    <BlockMenuList
      onSelect={onSelect}
      onClick={onClick}
      options={calculateOptions}
      direction={direction}
    />
  )
}

export default BlockMenu
